import React from 'react';

import { Avatar } from '../Avatar/Avatar';

import style from './ChatBubble.scss';

import cn from 'classnames';

interface IProps {
  primaryAuthor: {
    name: string;
    profile_image?: string;
    slug?: string;
  };
  isAlternate?: boolean;
  isAuthor?: boolean;
  children: React.ReactNode;
}

export const ChatBubble = ({ primaryAuthor, children, isAlternate, isAuthor = true }: IProps) => {
  const { name, profile_image = '' } = primaryAuthor;
  return (
    <div
      className={cn(style.wrapper, { [style.alternate]: isAlternate, [style.isSingle]: isAuthor })}
    >
      <Avatar className={style.image} profile_image={profile_image} name={name} />

      <div className={style.content}>
        <div className={style.triangle}></div>
        {children}
      </div>
    </div>
  );
};
